document.addEventListener('DOMContentLoaded', function () {

  function updateButtons() {

    const forms = document.querySelectorAll('.membership-form');
    if (!forms.length) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        forms.forEach(form => {

          const idInput = form.querySelector('input[name="id"]');
          const button = form.querySelector('button');
          if (!idInput || !button) return;

          const variantId = parseInt(idInput.value, 10);

          const alreadyInCart = cart.items.some(item =>
            parseInt(item.variant_id, 10) === variantId
          );

          if (alreadyInCart) {
            button.disabled = true;
            button.classList.add('is-disabled');
            button.innerText = "Already a Member";
          } else {
            button.disabled = false;
            button.classList.remove('is-disabled');
            button.innerText = form.dataset.originalText;
          }

        });

      })
      .catch(console.error);
  }

  function initButtons() {

    const forms = document.querySelectorAll('.membership-form');
    if (!forms.length) return;

    forms.forEach(form => {

      const button = form.querySelector('button');
      if (!button) return;

      if (!form.dataset.originalText) {
        form.dataset.originalText = button.innerText;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(() => {
          window.location.href = '/cart';
        })
        .catch(console.error);
      });

    });

  }

  /* 🔥 Intercept FETCH */
  const originalFetch = window.fetch;
  window.fetch = function () {

    const result = originalFetch.apply(this, arguments);

    if (arguments[0] && typeof arguments[0] === 'string') {
      if (
        arguments[0].includes('/cart/change') ||
        arguments[0].includes('/cart/update') ||
        arguments[0].includes('/cart/add')
      ) {
        result.then(() => {
          setTimeout(updateButtons, 400);
        });
      }
    }

    return result;
  };

  /* 🔥 Intercept XHR */
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {

    this.addEventListener('load', function () {
      if (
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/add')
      ) {
        setTimeout(updateButtons, 400);
      }
    });

    return originalOpen.apply(this, arguments);
  };

  initButtons();
  updateButtons();

});